import { GridRowMutationAction, GridRowMutationResponse } from './mutate-grid-resource-row.model';

export enum MutateMasterSubmitRowRequestKeys {
  action = 'action',
  rowKey = 'rowKey',
  values = 'values',
}

export interface MutateMasterSubmitRowRequest {
  [MutateMasterSubmitRowRequestKeys.action]: GridRowMutationAction;
  [MutateMasterSubmitRowRequestKeys.rowKey]?: string | number | null;
  [MutateMasterSubmitRowRequestKeys.values]?: Record<string, unknown> | null;
}

export type MutateMasterSubmitRowResponse = GridRowMutationResponse;

